import React, { useState } from 'react';
import { MdAdd, MdGroup, MdEdit, MdDelete, MdVisibility, MdSearch, MdFilterList } from 'react-icons/md';
import ResultModal from './ResultModal';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../../styles/views.css';

const GroupsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddGroupModalOpen,
  setEditGroup,
  setIsEditGroupModalOpen,
  setViewGroup,
  setIsViewGroupModalOpen,
  loading,
  userRole,
  userMmdaId,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen width for responsive behavior
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Result modal states
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultModalData, setResultModalData] = useState({
    type: 'success',
    operation: 'Deleted',
    itemType: 'Group',
    itemName: '',
    details: null
  });

  // Handle delete group
  const handleDeleteGroup = async (group) => {
    if (window.confirm(`Are you sure you want to delete "${group.group_name}"?`)) {
      try {
        // Simulate delete operation
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Show success modal
        setResultModalData({
          type: 'success',
          operation: 'Deleted',
          itemType: 'Group',
          itemName: group.group_name,
          details: 'Group has been permanently removed. All officers previously assigned to this group are now unassigned.'
        });
        setShowResultModal(true);

        console.log('Delete group:', group);
      } catch (error) {
        // Show error modal
        setResultModalData({
          type: 'error',
          operation: 'Delete',
          itemType: 'Group',
          itemName: group.group_name,
          details: `Error: ${error.message || 'Failed to delete group'}`
        });
        setShowResultModal(true);
      }
    }
  };
  const handleEditGroup = (group) => {
    setEditGroup(group);
    setIsEditGroupModalOpen(true);
  };

  return (
    <>
      {/* Enhanced Groups Management Header */}
      <div style={{
        marginBottom: 24,
        padding: isMobile ? '15px 18px' : '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          gap: isMobile ? '12px' : '0',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdGroup size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: isMobile ? 16 : 18, fontWeight: '600' }}>
              Groups Management
            </h3>
            <span style={{
              padding: '4px 12px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {pagedFilteredData?.length || 0} Groups
            </span>
          </div>

          <button
            onClick={() => setIsAddGroupModalOpen(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              padding: isMobile ? '8px 12px' : '10px 16px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: isMobile ? 13 : 14,
              fontWeight: '600',
              boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
              transition: 'all 0.2s ease',
              width: isMobile ? '100%' : 'auto'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#218838';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#28a745';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.3)';
            }}
          >
            <MdAdd size={18} />
            {isMobile ? 'Add Group' : 'Add New Group'}
          </button>
        </div>

        {/* Enhanced Search Controls */}
        <div style={{ position: 'relative', maxWidth: 400 }}>
          <MdSearch size={20} style={{
            position: 'absolute',
            left: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666'
          }} />
          <input
            type="text"
            placeholder="Search groups by name, zone, or members..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px 10px 40px',
              borderRadius: 8,
              border: '1px solid #ddd',
              fontSize: 14,
              outline: 'none',
              transition: 'border-color 0.2s ease',
              boxSizing: 'border-box'
            }}
            onFocus={e => e.target.style.borderColor = '#1976d2'}
            onBlur={e => e.target.style.borderColor = '#ddd'}
          />
        </div>
      </div>

      {/* Groups Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Group Name</th>
                <th>Zone</th>

                <th>Members</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
 
                      <strong>{row.group_name}</strong>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {row.zone_name}
                    </span>
                  </td>

                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: 4,
                      fontSize: 12,
                      color: '#666'
                    }}>
                      {row.member_count || 0} members
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => handleEditGroup(row)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff9800',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdEdit size={14} />
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          setViewGroup(row);
                          setIsViewGroupModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdVisibility size={14} />
                        View
                      </button>

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Group Management Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#e8f5e8',
        borderRadius: 8,
        border: '1px solid #c8e6c9',
        fontSize: 14,
        color: '#2e7d32'
      }}>
        <strong>Group Management:</strong> Groups help organize revenue officers and traders within zones.
        You can create, edit, and manage groups within your MMDA region to improve operational efficiency.
      </div>

      {/* Result Modal for Delete Operations */}
      <ResultModal
        isOpen={showResultModal}
        onClose={() => setShowResultModal(false)}
        type={resultModalData.type}
        operation={resultModalData.operation}
        itemType={resultModalData.itemType}
        itemName={resultModalData.itemName}
        details={resultModalData.details}
      />
    </>
  );
};

export default GroupsView;
